<template>
  <div id="foreignOutbounds">
    <div v-if="kycFlag" class="kyc-alert">
      <a-alert v-if="kycStatus === 'CUSTOMER'" banner>
        <template #message>
          <span>{{ $t('pages_pay_161') }}</span>
          <a>{{ $t('pages_pay_162') }}</a>
        </template>
      </a-alert>
      <a-alert v-else-if="kycStatus === 'CUSTREJ'" banner>
        <template #message>
          <span>{{ $t('pages_pay_160') }}</span>
          <a>{{ $t('pages_pay_162') }}</a>
        </template>
      </a-alert>
      <a-alert v-else :message="$t('pages_pay_159')" banner />
    </div>
    <div v-else>
      <div class="search-form ant-round-form">
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_076') }}: </span>
          <a-input
            v-model:value="searchQuery.batchNo"
            allow-clear
            @pressEnter="loadOutbounds(1)"
            @blur="loadOutbounds(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_077') }}: </span>
          <a-range-picker
            v-model:value="searchQuery.dateOpts"
            format="YYYY/MM/DD"
            value-format="YYYY-MM-DD"
            @change="loadOutbounds(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_078') }}: </span>
          <a-select
            v-model:value="searchQuery.paymentType"
            allow-clear
            @change="loadOutbounds(1)"
          >
            <a-select-option
              v-for="opt in payTypeOpts"
              :key="opt.code"
              :value="opt.code"
            >{{ opt.name }}</a-select-option>
          </a-select>
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_071') }}: </span>
          <a-select
            v-model:value="searchQuery.debitCurrency"
            show-search
            allow-clear
            option-filter-prop="label"
            @change="loadOutbounds(1)"
          >
            <a-select-option
              v-for="item in payCurList"
              :key="item.currency"
              :value="item.currency"
              :label="`${item.currency} - ${item.currencyName}`"
            >
              <img :src="getCountryLogo(item.currency)" class="select-img-country">
              <span>{{ item.currency }} - {{ item.currencyName }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_072') }}: </span>
          <a-select
            v-model:value="searchQuery.paymentCurrency"
            show-search
            allow-clear
            option-filter-prop="label"
            @change="loadOutbounds(1)"
          >
            <a-select-option
              v-for="item in receiveCurList"
              :key="item.currencyCode"
              :value="item.currencyCode"
              :label="`${item.currencyCode} - ${item.currencyName}`"
            >
              <img :src="getCountryLogo(item.imgName || item.currencyCode)" class="select-img-country">
              <span>{{ item.currencyCode }} - {{ item.currencyName }}</span>
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="table-part">
        <a-table
          :scroll="{ x: 1500 }"
          :loading="loading"
          :pagination="false"
          :custom-header-row="() => { return {class: 'my-table-tr'}}"
          :columns="columns"
          :data-source="outbounds"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'edit'">
              <a-space style="width: 100%; justify-content: space-between">
                <a-button
                  v-show="getUsedCheck(pageLabs, 150202)"
                  size="small"
                  type="link"
                  danger
                  @click="handleReview(record)"
                >{{ $t('pages_pay_016') }}
                </a-button>
                <a-divider v-show="getUsedCheck(pageLabs, 150202)" type="vertical" />
                <a-button
                  size="small"
                  type="link"
                  @click="handleView(record)"
                >{{ $t('pages_pay_083') }}
                </a-button>
              </a-space>
            </template>
          </template>
        </a-table>
        <table-page
          :total="total"
          :page-opts="searchQuery"
          @update-page="updatePage"
        />
      </div>
    </div>
    <a-modal
      :visible="repeatVisible"
      :mask-closable="false"
      :ok-button-props="{ disabled: countNum !== 0 }"
      :ok-text="countNum === 0 ? $t('pages_pay_068') : countNum + $t('pages_pay_186')"
      @ok="isChecked2(newPayItem)"
      @cancel="() => repeatVisible = false"
    >
      <template #title>
        <div class="flex-align">
          <exclamation-circle-outlined style="color: #faad14; font-size: 24px; margin-right: 12px;" />
          <span>{{ $t('pages_pay_179') }}</span>
        </div>
      </template>
      <div v-if="repeatList.length < 10" class="tip-body" style="margin-top: -12px">
        <span>{{ $t('pages_pay_180') }}</span>
        <span>{{ repeatDesc }}</span>
      </div>
      <div v-else class="tip-body" style="margin-top: -12px">
        <div>{{ $t('pages_pay_180') }}{{ repeatSize }}{{ $t('pages_pay_181') }}{{ hisCt }}{{ $t('pages_pay_182') }}</div>
        <div style="margin-top: 12px">
          {{ $t('pages_pay_265') }}
          <a-button type="link" size="small" @click="downFiles">{{ $t('pages_pay_266') }}</a-button>
          {{ $t('pages_pay_267') }}
        </div>
      </div>
      <div style="margin-top: 12px">
        {{ $t('pages_pay_183') }}
        <span style="color: #ff4d4f">{{ $t('pages_pay_184') }}</span>
        {{ $t('pages_pay_185') }}
      </div>
    </a-modal>
    <a-button type="primary" @click="showPaymentModal">显示付款信息</a-button>

    <a-modal
      v-model:visible="paymentModalVisible"
      wrap-class-name="outbounds-edit-modal"
      :title="editName !== 'view' ? `${$t('pages_pay_076')}: ${currentBatchApplyNo}` : $t('pages_pay_104')"
      :visible="visible"
      :width="900"
      :mask-closable="false"
    >
      <a-spin :spinning="paymentModalLoading">
        <div v-if="bankPaymentInfo.length > 0">
          <div class="title">
            <money-collect-filled class="ic-transact" />
            <span class="title-text"> 付款到银行卡 </span>
          </div>

          <div class="payment-info">
            <div v-for="(info, index) in bankPaymentInfo" :key="index" class="info-item">
              <span>汇款国家：{{ info.country }}</span>
              <span>付款笔数：{{ info.count }}笔</span>
              <span>扣款金额：{{ info.amount }} {{ info.curType }} </span>
            </div>
          </div>
        </div>
        <div v-if="walletPaymentInfo.length > 0">
          <div class="title">
            <money-collect-filled class="ic-transact" />
            <span class="title-text">付款到钱包 </span>
          </div>

          <div class="payment-info">
            <div v-for="(info, index) in walletPaymentInfo" :key="index" class="info-item">
              <span>汇款国家：{{ info.country }}</span>
              <span>付款笔数：{{ info.count }}笔</span>
              <span>扣款金额：{{ info.amount }}</span>
            </div>
          </div>
        </div>
      </a-spin>
      <template #footer>
        <div class="flex-align">
          <a-button
            type="primary"
            danger
            @click="handlePass('03')"
          >{{ $t('pages_pay_100') }}</a-button>
          <div class="flex-align" style="margin-left: auto">
            <a-button @click="paymentModalVisible = false">{{ $t('common_text_024') }}</a-button>
            <a-button
              type="primary"
              :loading="reviewPassLoading"
              @click="reviewPass"
            >{{ $t('pages_pay_099') }}</a-button>
          </div>
        </div>
      </template>
    </a-modal>

    <edit-modal
      ref="editRef"
      v-model:visible="visible"
      @refresh="handleRefresh"
    />

    <password-modal
      v-model:visible="passwordVisible"
      @pass="handleVerify"
    />
    <verify-modal
      v-model:visible="verifyVisible"
      :bind-info="bindInfo"
      @pass="e => handlePass('02', e)"
    />
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import TablePage from '@/components/table-page'
import EditModal from './components/edit-modal'
import { _pay, _account, _oss, _user } from '@/api'
import { getUsedCheck, getAttrStatusList, getTradeStatusName, getCountryLogo, parseMoney } from '@/util'
import i18n from '@/locale'
import moment from 'moment'
import PasswordModal from '@/components/password-modal'
import VerifyModal from '@/components/verify-modal'
import { message } from 'ant-design-vue'
import { _home } from '@/api/index'
export default {
  name: 'ForeignOutbounds',
  components: {
    'table-page': TablePage,
    'edit-modal': EditModal,
    'password-modal': PasswordModal,
    'verify-modal': VerifyModal
  },
  props: {
    payCurList: {
      type: Array,
      default: () => {
        return []
      }
    },
    receiveCurList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup() {
    let timer = ''
    const editRef = ref(null)
    const store = useStore()
    const state = reactive({
      paymentModalVisible: false,
      currentBatchApplyNo: '',
      paymentModalLoading: true,
      passwordVisible: false,
      reviewDisabled: false,
      loading: false,
      visible: false,
      repeatVisible: false,
      applyVisible: false,
      needCheck: false,
      kycFlag: false,
      kycStatus: '',
      pageLabs: [],
      outbounds: [],
      total: 0,
      countNum: 5,
      newPayItem: {},
      repeatList: [],
      detailInfo: {},
      repeatSize: 0,
      repeatDesc: '',
      repeatFilePath: '',
      hisCt: 0,
      searchQuery: {
        pageNum: 1,
        pageSize: 10,
        batchNo: '',
        paymentType: '',
        dateOpts: [],
        debitCurrency: '',
        paymentCurrency: ''
      },
      bankPaymentInfo: [
      ],
      walletPaymentInfo: [
      ],
      columns: [
        { key: 'paymentType', dataIndex: 'paymentTypeText', title: i18n.global.t('pages_pay_078'), width: 120 },
        { key: 'batchApplyNo', dataIndex: 'batchApplyNo', title: i18n.global.t('pages_pay_076'), width: 200 },
        { key: 'applyCnt', dataIndex: 'applyCnt', title: i18n.global.t('pages_pay_080'), width: 180 },
        { key: 'uploadFilename', dataIndex: 'uploadFilename', title: i18n.global.t('pages_pay_262'), width: 300 },
        { key: 'createDate', dataIndex: 'createAt', title: i18n.global.t('pages_pay_077'), width: 200 },
        { key: 'remitAmount', dataIndex: 'remitAmountText', title: i18n.global.t('pages_pay_032'), width: 200 },
        { key: 'arrivalAmount', dataIndex: 'arrivalAmountText', title: i18n.global.t('pages_pay_081'), width: localStorage.getItem('locale-language') === 'en' ? 220 : 200 },
        { key: 'feeAmt', dataIndex: 'feeAmtText', title: i18n.global.t('pages_pay_369'), width: 200 },
        { key: 'edit', title: i18n.global.t('common_text_001'), align: 'center', fixed: 'right', width: localStorage.getItem('locale-language') === 'en' ? 230 : 175 }
      ],
      editName: '',
      reviewPassLoading: false
    })
    state.payTypeOpts = computed(() => {
      return getAttrStatusList('outboundPayModel')
    })

    const downFiles = async () => {
      const res = await _oss.querySsoTempUrl({ filePath: state.repeatFilePath })
      window.open(res.data.data)
    }

    const exportList = async () => {
      const { dateOpts } = state.searchQuery
      const query = Object.assign({}, state.searchQuery, {
        beginDate: dateOpts[0] ? `${dateOpts[0]} 00:00:00` : '',
        endDate: dateOpts[1] ? `${dateOpts[1]} 23:59:59` : ''
      })
      await _pay.outboundsReviewExport(query)
    }

    const updatePage = (page, pageSize) => {
      state.searchQuery.pageNum = page
      state.searchQuery.pageSize = pageSize
      loadOutbounds()
    }

    const handleRefresh = () => {
      state.paymentModalVisible = false
      loadOutbounds()
    }

    const handleView = (record) => {
      state.visible = true
      editRef.value.loadPage(record, 'view')
    }

    const handleReview = async (record) => {
      state.currentBatchApplyNo = record.batchApplyNo
      const res = await _pay.checkRecentRepeatOrder({
        batchApplyNo: record.batchApplyNo,
        business: 'OUTBOUND'
      })
      if (res.data.succ && res.data.data) {
        clearInterval(timer)
        const { list, repeatSize, hisCt, repeatFilePath } = res.data.data

        state.countNum = 5
        state.newPayItem = record
        state.repeatList = list
        state.repeatSize = repeatSize
        state.repeatDesc = list.map(item => item.errorMsg).join(',')
        state.hisCt = hisCt
        state.repeatFilePath = repeatFilePath
        state.repeatVisible = true

        timer = setInterval(() => {
          state.countNum--
          if (state.countNum <= 0) clearInterval(timer)
        }, 1000)
      } else {
        handleReview1(record)
      }
    }

    const handleReview1 = async (record) => {
      state.bankPaymentInfo = []
      state.walletPaymentInfo = []
      const res = await _pay.checkRecentRepeatOrder({
        batchApplyNo: record.batchApplyNo,
        business: 'OUTBOUND'
      })
      if (res.data.succ && res.data.data) {
      } else {
        const querySp = await _pay.querySpecialUser({
          paramName: 'out_international'
        })
        const specialMerchantNosFromQuery = querySp.data.data
        const userInfo = store.getters.getUserInfo
        const merchantNo = userInfo.merchantNo
        if (specialMerchantNosFromQuery.includes(merchantNo) && record.paymentType !== '01') {
          state.paymentModalVisible = true
          state.paymentModalLoading = true
          const batchNo = record.batchApplyNo
          const res = await _pay.outReviewDetail({ batchNo })
          if (res.data.succ) {
            state.bankPaymentInfo = res.data.data.bankPaymentInfo
            state.walletPaymentInfo = res.data.data.walletPaymentInfo
            state.paymentModalLoading = false
            state.editName = 'review'
            editRef.value.loadPage(record, 'review')
          } else {
            state.paymentModalLoading = false
          }
        } else {
          state.visible = true
          state.editName = 'review'
          editRef.value.loadPage(record, 'review')
        }
      }
    }
    const showPaymentModal = async () => {
      state.paymentModalVisible = true
      state.paymentModalLoading = true
      state.paymentModalLoading = false
    }

    const isChecked2 = async (record) => {
      state.repeatVisible = false
      const querySp = await _pay.querySpecialUser({
        paramName: 'out_international'
      })
      const specialMerchantNosFromQuery = querySp.data.data
      const userInfo = store.getters.getUserInfo
      const merchantNo = userInfo.merchantNo
      if (specialMerchantNosFromQuery.includes(merchantNo)) {
        state.paymentModalVisible = true
        state.paymentModalLoading = true
        const batchNo = record.batchApplyNo
        const res = await _pay.outReviewDetail({ batchNo })
        if (res.data.succ) {
          state.bankPaymentInfo = res.data.data.bankPaymentInfo
          state.walletPaymentInfo = res.data.data.walletPaymentInfo
          state.paymentModalLoading = false
          state.editName = 'review'
          editRef.value.loadPage(record, 'review')
        } else {
          state.paymentModalLoading = false
        }
      } else {
        handleOk()
      }
    }

    const handleOk = () => {
      state.repeatVisible = false
      state.visible = true
      editRef.value.loadPage(state.newPayItem, 'review')
    }

    const loadPage = () => {
      const { status } = store.getters.getUserInfo

      if (status === 'OPENFINSH') {
        loadOutbounds()
      } else {
        state.kycStatus = status
        state.kycFlag = true
      }
    }

    const loadChildrenMenu = async () => {
      let pageLabs = []
      const res1 = await _account.getChildrenMenu({ parentId: 1502 })
      const res2 = await _account.getChildrenMenu({ parentId: 1702 })
      if (res1.data.succ) pageLabs = res1.data.data || []
      if (res2.data.succ) pageLabs = pageLabs.concat(res2.data.data || [])
      state.pageLabs = pageLabs
    }

    const loadMerchantProInfos = async () => {
      const userInfo = store.getters.getUserInfo
      const res = await _pay.getMerchantProInfos({
        merchantNo: userInfo.merchantNo,
        proId: 4
      })
      if (res.data.succ) {
        res.data.data.map(item => {
          if (item.isChecked === '01') {
            if (item.checkStatus === '02' || item.checkStatus === '01') {
              state.needCheck = false
            } else {
              state.needCheck = true
            }
          }
        })
      }
    }
    const handleVerify = async (token) => {
      state.passLoading = true
      const res = await _user.querySafetySwitch()

      if (res.data.succ) {
        if (res.data.data.isOnOff) {
          state.bindInfo = res.data.data
          if (res.data.data.mobile) {
            const num = state.bindInfo.mobile.length - 7
            const reg = new RegExp(`(\\d{3})\\d{${num}}(\\d{4})`)
            state.bindInfo.formatMobile = state.bindInfo.mobile.replace(reg, '$1****$2')
          }
          state.verifyVisible = true
        } else {
          handlePass('02', token)
        }
      }
    }

    // const handleBatchApply = async () => {
    //   const resMerchant = await _home.getMerchantInfo()
    //   console.log('resMerchant', resMerchant)
    //   if (resMerchant.data.succ) {
    //     const { merchantNo } = resMerchant.data.data
    //     console.log('merchantNo', merchantNo)
    //     if (specialMerchantNos.includes(merchantNo)) {
    //       router.push('/funds/outbounds/fixedBatch_apply')
    //     } else {
    //       router.push('/funds/outbounds/batch_apply')
    //     }
    //   }
    // }
    const handlePass = async (status, token) => {
      const resMerchant = await _home.getMerchantInfo()
      if (status === '02') state.passLoading = true
      else state.rejectLoading = true
      const res = await _pay.paymentSubmit({
        status,
        token,
        id: resMerchant.data.data.id,
        batchNo: state.currentBatchApplyNo,
        feeRateId: state.detailInfo.feeRateId,
        amtFeeRateId: state.detailInfo.amtFeeRateId,
        payeeFeeRateId: state.detailInfo.payeeFeeRateId,
        isExchange: state.detailInfo.isExchange,
        feeRate: state.detailInfo.rate
      })
      if (res.data.succ) {
        store.dispatch('getCurList')
        message.success(i18n.global.t(status === '02' ? 'pages_pay_101' : 'pages_pay_103'))
        loadOutbounds()
      } else {
        message.error(res.data.resMsg)
      }
      state.passLoading = false
      state.rejectLoading = false
    }
    const loadOutbounds = async (pageNum) => {
      state.loading = true
      if (!state.searchQuery.dateOpts) state.searchQuery.dateOpts = []
      if (pageNum) state.searchQuery.pageNum = pageNum
      const { dateOpts } = state.searchQuery
      const query = Object.assign({}, state.searchQuery, {
        beginDate: dateOpts[0] ? `${dateOpts[0]} 00:00:00` : '',
        endDate: dateOpts[1] ? `${dateOpts[1]} 23:59:59` : ''
      })
      const res = await _pay.getForeignPayConfirmList(query)
      if (res.data.succ) {
        state.outbounds = res.data.data.pageInfo.list.map(item => {
          return Object.assign({}, item, {
            paymentTypeText: getTradeStatusName(item.paymentType, 'outboundPayModel'),
            remitAmountText: item.debitAmt ? `${item.debitCurrency} ${parseMoney(item.debitAmt)}` : '-',
            arrivalAmountText: item.paymentAmt ? `${item.paymentCurrency} ${parseMoney(item.paymentAmt)}` : '-',
            feeAmtText: item.feeAmt ? `${item.feeCurrency} ${parseMoney(item.feeAmt)}` : '-',
            statusText: getTradeStatusName(item.applyStatus, 'payStatus'),
            createAt: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
          })
        })
        state.total = res.data.data.pageInfo.total
      }
      state.loading = false
      state.passLoading = false
      state.paymentModalVisible = false
      state.reviewPassLoading = false
    }
    const reviewPass = async () => {
      state.reviewPassLoading = true
      state.passLoading = true
      const res = await _pay.isPayPwdExist()
      if (res.data.data) {
        state.passwordVisible = true
      } else {
        Modal.warning({
          title: i18n.global.t('common_text_037'),
          content: i18n.global.t('common_text_038') + i18n.global.t('common_text_039'),
          okText: i18n.global.t('common_text_039'),
          onOk() {
            router.push({ path: '/user/account_security', query: { labName: 'payPwd' }})
          }
        })
      }
      state.passLoading = false
    }

    const init = () => {
      loadChildrenMenu()
      loadMerchantProInfos()
      loadPage()
    }

    return {
      editRef,
      getUsedCheck,
      getCountryLogo,
      init,
      isChecked2,
      downFiles,
      handleOk,
      updatePage,
      handleRefresh,
      handleView,
      handleReview,
      loadOutbounds,
      exportList,
      showPaymentModal,
      reviewPass,
      handleVerify,
      handlePass,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="less" scoped>
#foreignOutbounds {
  text-align: left;

  .kyc-alert {
    margin-top: 24px;
  }

  .search-form {
    margin-top: 8px;
  }

  .table-part {
    margin-top: 12px;
  }
}

.payment-info {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.info-item span {
  margin-right: 20px;
}
.title-text {
  font-size: 18px;
  font-weight: bold;
}

</style>
